import axios from 'axios'
// import xMan from "@/utils/xMan";
import { ApiConfig } from '@/config/ApiConfig'
import { RiderUserConfig } from '@/config/RiderUserConfig'

export default {
  namespaced: true,

  state: {
    // status (idle/busy/succeeded/failed)
    status: 'idle',
    // current vehicle data
    id: undefined,
    data: undefined,
  },
  getters: {
    getId: (state) => {
      return state.id || null
    },
    getData: (state) => {
      return state.data || null
    },
    getStatus: (state) => {
      return state.status
    },
    isLoading: (state) => {
      return state.status === 'busy' ?? false
    },
  },
  mutations: {
    STATUS_IDLE(state) {
      state.status = 'idle'
    },
    STATUS_BUSY(state) {
      state.status = 'busy'
    },
    STATUS_FAILED(state) {
      state.status = 'failed'
    },
    STATUS_SUCCEEDED(state) {
      state.status = 'succeeded'
    },
    REMEMBER_ID(state, payload) {
      state.id = payload
    },
    FORGET_ID(state) {
      state.id = undefined
    },
    REMEMBER_DATA(state, payload) {
      state.data = payload
    },
    FORGET_DATA(state) {
      state.data = undefined
    },
    SAVE_STATUS(state, payload) {
      state.data.user_status = payload
    },
    SAVE_BALANCE(state, payload) {
      state.data.profile.balance = payload
    },
  },
  actions: {
    async fetchData({ commit }, payload) {
      commit('STATUS_BUSY')
      commit('FORGET_ID')
      commit('FORGET_DATA')
      commit('REMEMBER_ID', payload)
      await axios
        .get(RiderUserConfig.api.single(payload), ApiConfig.options)
        .then((res) => {
          // console.log({vd: res.data});
          commit('REMEMBER_DATA', res.data)
          commit('STATUS_SUCCEEDED')
          return res
        })
        .catch((err) => {
          commit('STATUS_FAILED')
          // console.log({vde: err});
          throw new Error(err)
        })
        .finally(() => {
          commit('STATUS_IDLE')
        })
    },
    saveData({ commit }, payload) {
      commit('STATUS_BUSY')
      commit('FORGET_DATA')

      commit('REMEMBER_DATA', payload)
      // console.log({ vdS: payload });
      commit('STATUS_SUCCEEDED')
      commit('STATUS_IDLE')
    },
    saveId({ commit }, payload) {
      commit('STATUS_BUSY')
      commit('FORGET_ID')

      commit('REMEMBER_ID', payload)

      commit('STATUS_SUCCEEDED')
      commit('STATUS_IDLE')
    },
    saveStatus({ commit }, payload) {
      commit('STATUS_BUSY')
      console.warn({ status: payload })
      const whitelist = ['H', 'A', 'D']
      if (whitelist.indexOf(payload) === -1) {
        commit('STATUS_FAILED')
        commit('STATUS_IDLE')
        return
      }

      commit('SAVE_STATUS', payload)

      commit('STATUS_SUCCEEDED')
      commit('STATUS_IDLE')
    },
    saveBalance({ commit }, payload) {
      commit('SAVE_BALANCE', payload)
    },
  },
}
